"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_modal_1 = __importDefault(require("react-modal"));
function Modal({ isOpen, setIsOpen, children, onAfterOpen, onRequestClose, contentLabel, contentClassName = '', modalTestId, closeBtnTestId, withCloseButton = true, }) {
    const rootElement = document.getElementById('root');
    const handleClose = () => {
        if (onRequestClose) {
            onRequestClose();
        }
        setIsOpen(false);
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "modal-container", children: (0, jsx_runtime_1.jsx)(react_modal_1.default, { isOpen: isOpen, onRequestClose: onRequestClose, onAfterOpen: onAfterOpen, contentLabel: contentLabel, appElement: rootElement || undefined, portalClassName: isOpen ? 'modal is-active' : 'modal is-inactive', className: (0, classnames_1.default)('modal-inner', contentClassName), overlayClassName: "modal-fade-screen", bodyOpenClassName: "modal-open", "data-testid": modalTestId, children: (0, jsx_runtime_1.jsxs)("div", { "data-testid": modalTestId, children: [withCloseButton ? ((0, jsx_runtime_1.jsx)("div", { className: "modal-close-btn-container", children: (0, jsx_runtime_1.jsx)("button", { onClick: handleClose, className: "modal-close", "aria-label": "Close Modal", "data-testid": closeBtnTestId, children: "\u00D7" }) })) : null, children] }) }) }));
}
exports.default = Modal;
